<div id="global-loader" class="global-loader" *ngIf="isLoading">
    <div class="spinner"></div>
</div>
<div class="page-card" [ngStyle]="{'height': scrHeight}">
    <div class="email-layout">
        <!-- Left sidebar -->
        <div class="sidebar">
            <div class="border rounded-2 d-flex flex-column h-100 overflow-hidden mb-2" style="border-color: #E5E7EB !important;">
                <!-- Template Header -->
                <div class="d-flex justify-content-between align-items-center p-3 border-bottom" style="background-color: #fafafa; border-color: #E5E7EB !important;">
                    <div class="d-flex align-items-center gap-2">
                        <div>
                            <svg width="30" height="40" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
                                fill="none" stroke="#ef4444" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" aria-hidden="true">
                                <path
                                    d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z">
                                </path>
                                <path d="M14 2v5a1 1 0 0 0 1 1h5"></path>
                                <path d="M10 9H8"></path>
                                <path d="M16 13H8"></path>
                                <path d="M16 17H8"></path>
                            </svg>
                        </div>
                        <div class="d-flex flex-column">
                            <label class="mb-0 fw-normal">Quick Templates</label>
                            <span class="text-muted" style="font-size: 12px;">{{emailTemplates.length}} templates</span>
                        </div>
                    </div>
                    <button class="btn btn-danger d-flex align-items-center gap-1 px-3 py-2" 
                            style="background-color: #CC0000; border-color: #CC0000; font-size: 14px; font-weight: 600; height: 40px; border-radius: 8px;"
                            (click)="addNewTemplate()">
                        <mat-icon style="font-size: 18px; width: 18px; height: 18px;">add</mat-icon>
                        <span>New</span>
                    </button>
                </div>

                <!-- Search Container -->
                <div class="position-relative p-3 border-bottom" style="border-color: #E5E7EB !important;">
                    <mat-icon class="position-absolute" style="left: 28px; top: 50%; transform: translateY(-50%); color: #6b7280; font-size: 20px; width: 20px; height: 20px;">search</mat-icon>
                    <input type="text" class="form-control ps-5" 
                           style="background-color: #fafafa; border-color: #e5e7eb; border-radius: 8px; font-size: 14px;"
                           placeholder="Search templates..." [(ngModel)]="templateSearchQuery" (input)="filterTemplates()">
                </div>

                <!-- Template Cards List -->
                <div class="d-flex flex-column gap-3 p-3 overflow-auto flex-grow-1">
                    <div class="card template-card"
                        [class.selected]="selectedTemplateId === template.template_id"
                        *ngFor="let template of filteredEmailTemplates"
                        (click)="applyTemplate(template)"
                        style="cursor: pointer; border-color: #E5E7EB; border-radius: 8px; background-color: #fafafa;">
                        <div class="card-body p-3">
                            <div class="d-flex flex-column gap-2">
                                <!-- Card Header -->
                                <div class="d-flex flex-column">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <span class="fw-normal" style="font-size: 14px; line-height: 1.4;">{{ template.template_name }}</span>
                                        <div class="edit-icon d-flex align-items-center justify-content-center" 
                                             [matTooltip]="'Edit template'"
                                             style="width: 32px; height: 32px; border-radius: 50%; cursor: pointer;"
                                             (click)="editTemplate(template, $event)">
                                            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" 
                                                 style="width: 18px; height: 18px; fill: #777;">
                                                <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
                                            </svg>
                                        </div>
                                    </div>

                                    <div class="d-flex align-items-center gap-1 mt-1" style="font-size: 12px; color: #6B7280;">
                                        <mat-icon style="font-size: 14px; width: 14px; height: 14px;">schedule</mat-icon>
                                        <span>Created {{ template.timeAgo }}</span>
                                    </div>
                                </div>
                                <!-- Use Template Button -->
                                <button class="btn w-100 fw-normal" 
                                        style="padding: 8px 16px; background-color: #fff; color: #CC0000; border: 2px solid #CC0000; border-radius: 6px; font-size: 14px;"
                                        (click)="applyTemplate(template); $event.stopPropagation()">
                                    {{ selectedTemplateId === (template.id || template.template_id) ? 'Selected' : 'Use Template' }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Main compose area -->
        <div class="compose-area">
            <div class="header mb-2">
                <!-- <div style="display: flex;flex-direction:column"> -->
                <label>Compose Email</label>
                <!-- <p style="font-size:12px ,; color:#737b8a">Draft your compliance communication</p>
               </div> -->
                <button class="btn-recipients">{{ emails.length }} Recipients</button>
            </div>

            <form [formGroup]="emailForm" class="compose-form">
                <!-- To field with full width -->

                <div class="row align-items-start mb-0 py-2 border-bottom">
                    <div class="col-auto" style="min-width: 40px;">
                        <label class="mb-0 fw-medium" style="font-size: 14px; color: #374151;">To:</label>
                    </div>
                    <div class="col">
                        <div class="d-flex flex-wrap align-items-center gap-2" style="min-height: 36px;">
                            <span class="badge d-inline-flex align-items-center gap-1 px-2 py-1"
                                style="background-color: #f3f4f6; border: 1px solid #e5e7eb; color: #374151; font-weight: normal; border-radius: 6px;"
                                *ngFor="let email of emails; let i = index">
                                <mat-icon
                                    style="font-size: 16px; width: 16px; height: 16px; color: #6b7280;">mail_outline</mat-icon>
                                <span style="font-size: 13px;">{{ email }}</span>
                                <button type="button" class="btn-close"
                                    style="font-size: 10px; padding: 0; margin-left: 4px;" (click)="removeEmail(i)"
                                    aria-label="Remove"></button>
                            </span>
                            <div class="email-input-chip d-inline-flex align-items-center flex-grow-1">
                                <input type="text" class="border-0 flex-grow-1 email-input"
                                    style="outline: none; background: transparent; font-size: 13px; min-width: 150px;"
                                    placeholder="Add email address here..." (keydown.enter)="addEmail($event)"
                                    #emailInput />
                            </div>
                        </div>
                        <input type="hidden" formControlName="to" />
                    </div>
                    <div class="col-auto">
                        <div class="d-flex align-items-start gap-2">
                            <button type="button" *ngIf="!showCc" (click)="toggleCcBcc('cc')"
                                class="btn btn-link btn-sm text-decoration-none p-0"
                                style="color: #555; font-size: 13px;">+ Cc</button>
                            <button type="button" *ngIf="!showBcc" (click)="toggleCcBcc('bcc')"
                                class="btn btn-link btn-sm text-decoration-none p-0"
                                style="color: #555; font-size: 13px;">+ Bcc</button>
                        </div>
                    </div>
                </div>

                <div *ngIf="showCc" class="row align-items-center mb-0 py-2 border-bottom">
                    <div class="col-auto" style="min-width: 40px;">
                        <label class="mb-0 fw-medium" style="font-size: 14px; color: #374151;">Cc:</label>
                    </div>
                    <div class="col">
                        <div class="d-flex flex-wrap align-items-center gap-2" style="min-height: 36px;">
                            <span class="badge d-inline-flex align-items-center gap-1 px-2 py-1"
                                style="background-color: #f3f4f6; border: 1px solid #e5e7eb; color: #374151; font-weight: normal; border-radius: 6px;"
                                *ngFor="let email of ccEmails; let i = index">
                                <mat-icon
                                    style="font-size: 16px; width: 16px; height: 16px; color: #6b7280;">mail_outline</mat-icon>
                                <span style="font-size: 13px;">{{ email }}</span>
                                <button type="button" class="btn-close"
                                    style="font-size: 10px; padding: 0; margin-left: 4px;" (click)="removeCcEmail(i)"
                                    aria-label="Remove"></button>
                            </span>
                            <div class="email-input-chip d-inline-flex align-items-center flex-grow-1">
                                <input type="text" class="border-0 flex-grow-1 email-input"
                                    style="outline: none; background: transparent; font-size: 13px; min-width: 150px;"
                                    placeholder="Add CC email..." (keydown.enter)="addCcEmail($event)" #ccEmailInput />
                            </div>
                        </div>
                        <input type="hidden" formControlName="cc" />
                    </div>
                    <div class="col-auto">
                        <button type="button" (click)="remove('cc')" class="btn btn-link text-decoration-none p-0"
                            style="color: #dc2626; font-size: 13px; font-weight: 500;">Remove</button>
                    </div>
                </div>

                <div *ngIf="showBcc" class="row align-items-center mb-0 py-2 border-bottom">
                    <div class="col-auto" style="min-width: 40px;">
                        <label class="mb-0 fw-medium" style="font-size: 14px; color: #374151;">Bcc:</label>
                    </div>
                    <div class="col">
                        <div class="d-flex flex-wrap align-items-center gap-2" style="min-height: 36px;">
                            <span class="badge d-inline-flex align-items-center gap-1 px-2 py-1"
                                style="background-color: #f3f4f6; border: 1px solid #e5e7eb; color: #374151; font-weight: normal; border-radius: 6px;"
                                *ngFor="let email of bccEmails; let i = index">
                                <mat-icon
                                    style="font-size: 16px; width: 16px; height: 16px; color: #6b7280;">mail_outline</mat-icon>
                                <span style="font-size: 13px;">{{ email }}</span>
                                <button type="button" class="btn-close"
                                    style="font-size: 10px; padding: 0; margin-left: 4px;" (click)="removeBccEmail(i)"
                                    aria-label="Remove"></button>
                            </span>
                            <div class="email-input-chip d-inline-flex align-items-center flex-grow-1">
                                <input type="text" class="border-0 flex-grow-1 email-input"
                                    style="outline: none; background: transparent; font-size: 13px; min-width: 150px;"
                                    placeholder="Add BCC email..." (keydown.enter)="addBccEmail($event)"
                                    #bccEmailInput />
                            </div>
                        </div>
                        <input type="hidden" formControlName="bcc" />
                    </div>
                    <div class="col-auto">
                        <button type="button" (click)="remove('bcc')" class="btn btn-link text-decoration-none p-0"
                            style="color: #dc2626; font-size: 13px; font-weight: 500;">Remove</button>
                    </div>
                </div>

                <div class="row align-items-center mb-0 py-2">
                    <div class="col-auto" style="min-width: 40px;">
                        <label for="subject" class="mb-0 fw-medium"
                            style="font-size: 14px; color: #374151;">Subject:</label>
                    </div>
                    <div class="col">
                        <input id="subject" type="text" formControlName="subject"
                            class="form-control border-0 shadow-none p-0 ps-2"
                            style="background: transparent; font-size: 14px; color: #111827;"
                            placeholder="Please enter email subject..." />
                    </div>
                </div>

                <div class="editor form-row-textarea">
                    <ngx-editor-menu [editor]="editor" [toolbar]="toolbar">
                    </ngx-editor-menu>
                    <ngx-editor [editor]="editor" formControlName="body" placeholder="Please enter email body..."
                        (click)="onEditorClick($event)">
                    </ngx-editor>
                </div>

                <div class="compose-footer">
                    <div class="char-count">
                        {{ emailForm.get('body')?.value?.length || 0 }} characters
                    </div>
                </div>
            </form>
            <!-- Formatting Tips Info Box -->
            <div class="formatting-tips-box">
                <mat-icon class="icon-info-circle">info</mat-icon>
                <div class="formatting-tips-content">
                    <span><strong>Formatting Tips : </strong>
                        Use <strong>**bold**</strong>, <em>*italic*</em>, • bullets, or <strong>[link](url)</strong>
                        in your message.</span>
                </div>
            </div>

        </div>
        <!-- Template Popup -->
        <div class="template-popup-overlay" *ngIf="showTemplatePopup" (click)="closeTemplatePopup()">
            <div class="template-popup" (click)="$event.stopPropagation()">
                <div class="popup-header">
                    <div>{{ isEditingTemplate ? 'Edit Email Template' : 'Add New Email Template' }}</div>
                    <button class="close-btn" (click)="closeTemplatePopup()" [matTooltip]="'Close'">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
                <form [formGroup]="templateForm" class="template-form">
                    <div class="upper-block">
                        <div class="template-form-left">
                            <div class="form-field">
                                <label for="template-name">Template Name <span class="required">*</span></label>
                                <input id="template-name" type="text" formControlName="template_name"
                                    placeholder="Please enter template name..">
                            </div>

                            <div class="form-field">
                                <label for="template-subject">Email Subject</label>
                                <textarea id="template-subject" formControlName="email_subject" rows="2"
                                    placeholder="Please enter email subject..." (focus)="onSubjectFocus($event)"
                                    (click)="onSubjectClick($event)" (drop)="onDrop($event, 'subject')"
                                    (dragover)="onDragOver($event)"></textarea>
                            </div>
                        </div>

                        <!-- Attributes Available Section -->
                        <div class="attributes-section">
                            <label>Attributes Available <mat-icon class="info-icon">info</mat-icon></label>
                            <div class="attributes-grid">
                                <span class="attribute-chip" draggable="true"
                                    (dragstart)="onDragStart($event, '[Collection Name]')"
                                    (click)="insertPlaceholder('[Collection Name]')">Collection Name</span>
                                <span class="attribute-chip" draggable="true"
                                    (dragstart)="onDragStart($event, '[Project Name]')"
                                    (click)="insertPlaceholder('[Project Name]')">Project Name</span>
                                <span class="attribute-chip" draggable="true"
                                    (dragstart)="onDragStart($event, '[Department]')"
                                    (click)="insertPlaceholder('[Department]')">Department</span>
                                <span class="attribute-chip" draggable="true"
                                    (dragstart)="onDragStart($event, '[Due Date]')"
                                    (click)="insertPlaceholder('[Due Date]')">Due Date</span>
                                <span class="attribute-chip" draggable="true"
                                    (dragstart)="onDragStart($event, '[CNRA]')"
                                    (click)="insertPlaceholder('[CNRA]')">Contact Person</span>
                                <span class="attribute-chip" draggable="true"
                                    (dragstart)="onDragStart($event, '[Instruction Type]')"
                                    (click)="insertPlaceholder('[Instruction Type]')">Instruction Type</span>
                            </div>
                        </div>
                    </div>

                    <!-- Reuse existing editor toolbar for template body formatting -->
                    <div class="template-editor-toolbar form-row-textarea" (drop)="onDrop($event, 'body')"
                        (dragover)="onDragOver($event)" (click)="onBodyFocus()">
                        <ngx-editor-menu [editor]="popupEditor" [toolbar]="toolbar"></ngx-editor-menu>
                        <ngx-editor [editor]="popupEditor" formControlName="email_body" [outputFormat]="'html'"
                            placeholder="Please enter email body...">
                        </ngx-editor>
                    </div>

                    <div class="popup-actions">
                        <button type="button" class="btn-cancel" (click)="closeTemplatePopup()">Cancel</button>
                        <button type="button" class="btn-save" (click)="saveTemplate()" *ngIf="!isEditingTemplate"
                            [disabled]="!templateForm.get('template_name')?.valid">Save Template
                        </button>
                        <button type="button" class="btn-save" (click)="updateTemplate()" *ngIf="isEditingTemplate"
                            [disabled]="!templateForm.get('template_name')?.valid">Update Template
                        </button>
                    </div>
                </form>
            </div>
        </div>